module.exports = __webpack_public_path__ + "img/Wp_2078.ae10fe5d.png";